import { useFetchSubscriptionsQuery } from '../services/api/subscriptionApi/subscription';

export function useSubscriptions() {
  const result = useFetchSubscriptionsQuery();
  const subscriptions = result.data?.subscriptions || [];
  const activeSubscriptionsCurrency = result.data?.activeSubscriptionsCurrency;

  return {
    ...result,
    data: subscriptions,
    activeSubscriptionsCurrency,
  };
}
